module.exports = __webpack_public_path__ + "assets/click_and_collect.42e76c25.png";